<script>
import General from '@/services/General'

export default {
  name: 'modalReactions',
  data() {
    return {
      showModal: false,
      isBusy: false,
      contentId: null,
      title: null,
      summary: null,
      distribution: [],
      list: [],
      reactionCode: '',
      page: 1,
      limit: 20,
      totalItems: 0,
    }
  },
  computed: {
    totalReactions() {
      return this.summary?.total || 0
    },
    totalPagesComputed() {
      const total = Number(this.totalItems) || 0
      const perPage = Number(this.limit) || 1
      return Math.max(1, Math.ceil(total / perPage))
    },
    hasDistribution() {
      return this.distribution && this.distribution.length > 0
    },
    reactionColors() {
      const colors = ['primary', 'success', 'info', 'warning', 'danger', 'secondary']
      return this.distribution.reduce((acc, item, index) => {
        acc[item.reaction_code] = colors[index % colors.length]
        return acc
      }, {})
    }
  },
  methods: {
    async open(newsItem) {
      const contentId = newsItem && newsItem.source_id
      if (!contentId) return

      this.showModal = true
      this.isBusy = true
      this.contentId = contentId
      this.title = newsItem.title || contentId
      this.summary = null
      this.distribution = []
      // this.list = []
      // this.reactionCode = ''
      // this.page = 1
      // this.limit = 20
      // this.totalItems = 0

      try {
        // New requirement: show only summary/distribution response.
        const summaryRes = await General.getReaction(contentId)
        // Old code kept for reference:
        // const [summaryRes, listRes] = await Promise.all([
        //   General.getReaction(contentId),
        //   General.getReactionAll(contentId, { page: 1, limit: this.limit }),
        // ])

        const summary = summaryRes?.data?.data?.summary || null
        const distribution = summary?.distribution || []
        this.summary = summary
        this.distribution = Array.isArray(distribution) ? distribution : []

        // Old code kept for reference:
        // const listData = listRes?.data || {}
        // this.list = Array.isArray(listData.data) ? listData.data : []
        // this.totalItems = listData.total_items ?? 0
      } catch (e) {
        this.summary = null
        this.distribution = []
        // this.list = []
        // this.totalItems = 0
      } finally {
        this.isBusy = false
      }
    },

    async reloadList() {
      if (!this.contentId) return
      this.isBusy = true
      try {
        const params = {
          page: this.page,
          limit: this.limit,
        }
        if (this.reactionCode) {
          params.reaction_code = this.reactionCode
        }
        const listRes = await General.getReactionAll(this.contentId, params)
        const listData = listRes?.data || {}
        this.list = Array.isArray(listData.data) ? listData.data : []
        this.totalItems = listData.total_items ?? 0
      } catch (e) {
        this.list = []
        this.totalItems = 0
      } finally {
        this.isBusy = false
      }
    },

    closeModal() {
      this.showModal = false
    },

    // getReactionIcon(code) {
    //   const icons = {
    //     like: '👍',
    //     love: '❤️',
    //     laugh: '😄',
    //     wow: '😲',
    //     sad: '😢',
    //     angry: '😠',
    //   }
    //   return icons[code?.toLowerCase()] || '📊'
    // }
  },
}
</script>

<template>
  <b-modal
    id="news_reactions"
    size="lg"
    v-model="showModal"
    hide-footer
    body-class="p-0"
    modal-class="reactions-modal"
    centered
  >
    <template v-slot:modal-header>
      <div class="w-100">
        <div class="d-flex align-items-center mb-2">
          <div class="reaction-icon-wrapper me-3">
            <div class="reaction-icon-animation">R</div>
          </div>
          <div>
            <h5 class="modal-title fw-bold mb-0">Reactions</h5>
            <p class="text-muted mb-0 small">{{ title || 'Content reactions' }}</p>
          </div>
        </div>
      </div>
      <button type="button" class="btn-close" @click="closeModal" aria-label="Close"></button>
    </template>

    <!-- Loading State -->
    <div v-if="isBusy" class="loading-state text-center py-5">
      <div class="spinner-border text-primary mb-3" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="text-muted mb-0">Loading reactions...</p>
    </div>

    <div v-else class="reactions-content">
      <div class="list-section p-3">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <h6 class="mb-0 fw-semibold">
            <i class="bi bi-pie-chart me-2"></i>Reactions
            <span class="ms-2">{{ totalReactions.toLocaleString() }} total</span>
          </h6>
        </div>

        <div class="table-responsive">
          <table class="table table-hover reactions-table mb-0">
            <thead class="table-light">
              <tr>
                <th>Reaction</th>
                <th style="width: 160px;">Count</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!distribution || distribution.length === 0">
                <td colspan="2" class="text-center py-4">
                  <div class="text-muted">
                    <i class="bi bi-inbox fs-1 d-block mb-2"></i>
                    No reaction distribution found
                  </div>
                </td>
              </tr>
              <tr v-for="d in distribution" :key="d.reaction_code" class="reaction-row">
                <td>
                  <div class="reaction-text">
                    <div class="reaction-code">{{ d.reaction_code }}</div>
                  </div>
                </td>
                <td class="fw-mono small">{{ d.total }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Old detailed list block kept for reference
        <div class="d-flex align-items-center justify-content-between mb-3">
          <h6 class="mb-0 fw-semibold">
            <i class="bi bi-list-ul me-2"></i>Detailed List
            <span class="badge bg-secondary ms-2">{{ totalItems.toLocaleString() }} total</span>
          </h6>
          <div class="d-flex align-items-center gap-2">
            <label class="text-muted small mb-0">Filter by:</label>
            <b-form-select
              v-model="reactionCode"
              size="sm"
              class="reaction-filter"
              :options="[
                { value: '', text: 'All Reactions' },
                ...(distribution.map(d => ({
                  value: d.reaction_code,
                  text: `${d.reaction_code} (${d.total})`
                })))
              ]"
              @change="() => { page = 1; reloadList(); }"
            />
          </div>
        </div>

        <div class="pagination-section d-flex align-items-center justify-content-between mt-4 pt-2 flex-wrap gap-2">
          <div class="pagination-info text-muted small">
            <i class="bi bi-info-circle me-1"></i>
            Page {{ page }} of {{ totalPagesComputed }}
            <span class="mx-1">•</span>
            Showing {{ list.length }} of {{ (Number(totalItems) || 0).toLocaleString() }} items
          </div>
          <div class="dataTables_paginate paging_simple_numbers">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination
                v-model="page"
                :total-rows="totalItems"
                :per-page="limit"
                :disabled="isBusy"
                @input="reloadList"
              ></b-pagination>
            </ul>
          </div>
        </div>
        -->
      </div>
    </div>
  </b-modal>
</template>

<style scoped>
.reactions-modal .modal-content {
  border-radius: 16px;
  overflow: hidden;
  border: none;
}

.reaction-icon-wrapper {
  animation: pulse 2s ease-in-out infinite;
}

.reaction-icon-animation {
  font-size: 2rem;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1));
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

.loading-state {
  min-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.stat-card {
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: default;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1) !important;
}

.stat-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reaction-filter {
  width: auto;
  min-width: 150px;
  border-radius: 20px;
  cursor: pointer;
}

.progress {
  background-color: #e9ecef;
  border-radius: 10px;
  overflow: hidden;
}

.progress-bar {
  transition: width 0.6s ease;
}

.reaction-badge {
  font-weight: 500;
  font-size: 0.875rem;
  transition: transform 0.2s;
  cursor: pointer;
}

.reaction-badge:hover {
  transform: scale(1.05);
}

.reaction-text {
  color: inherit;
  display: inline-flex;
  flex-direction: column;
  line-height: 1.1;
}

.reaction-code {
  font-weight: 500;
  font-size: 0.95rem;
}

.reactions-table {
  font-size: 0.875rem;
}

.reactions-table thead th {
  border-top: none;
  font-weight: 600;
  color: #495057;
}

.reaction-row {
  transition: background-color 0.2s;
  cursor: default;
}

.reaction-row:hover {
  background-color: #f8f9fa;
}

.avatar-placeholder {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: bold;
}

.avatar-sm img {
  object-fit: cover;
}

.fw-mono {
  font-family: 'Courier New', monospace;
  font-weight: 500;
}

.pagination-info {
  font-size: 0.8125rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .reactions-table {
    font-size: 0.75rem;
  }
  
  .reactions-table th,
  .reactions-table td {
    padding: 0.5rem;
  }
}

/* Custom scrollbar */
.reactions-content::-webkit-scrollbar {
  width: 6px;
}

.reactions-content::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.reactions-content::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.reactions-content::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>